var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21371 4.79675C7.06294 4.94753 6.97058 5.15705 6.97088 5.38716L6.97088 5.48844C6.97088 5.94924 7.34391 6.32227 7.80412 6.32168L12.357 6.32168L4.65529 14.0234C4.33002 14.3487 4.33002 14.8767 4.65529 15.2019C4.98056 15.5272 5.50853 15.5272 5.8338 15.2019L13.5356 7.50019V12.0531C13.5356 12.5139 13.9086 12.8869 14.3688 12.8864H14.4701C14.9309 12.8864 15.3039 12.5133 15.3033 12.0531V5.38716C15.3033 4.92636 14.9303 4.55333 14.4701 4.55391L7.80412 4.55391C7.57372 4.55391 7.36449 4.64598 7.21371 4.79675Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.74932338180f909ce06d4c2fe0ea41ec.svg";
export { ForwardRef as ReactComponent };